import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { initTracking, getTrackingPayload } from "./lib/utm";
import { trackEvent } from "./lib/api";

// Landing sections
import Navbar from "./components/sections/Navbar";
import Hero from "./components/sections/Hero";
import StatsBar from "./components/sections/StatsBar";
import ClientLogos from "./components/sections/ClientLogos";
import Models from "./components/sections/Models";
import BudgetCalculator from "./components/sections/BudgetCalculator";
import Features from "./components/sections/Features";
import Niches from "./components/sections/Niches";
import Gallery from "./components/sections/Gallery";
import QuoteForm from "./components/sections/QuoteForm";
import Materials from "./components/sections/Materials";
import CatalogDownload from "./components/sections/CatalogDownload";
import FAQ from "./components/sections/FAQ";
import FinalCTA from "./components/sections/FinalCTA";
import Footer from "./components/sections/Footer";
import FloatingWhatsApp from "./components/sections/FloatingWhatsApp";
import SubscriptionPopup from "./components/sections/SubscriptionPopup";
import ScrollProgress from "./components/sections/ScrollProgress";
import StickyMobileCTAs from "./components/sections/StickyMobileCTAs";
import Process from "./components/sections/Process";
import SocialProof from "./components/sections/SocialProof";

// Admin
import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import Dashboard from "./admin/pages/Dashboard";
import LeadsList from "./admin/pages/LeadsList";
import LeadDetail from "./admin/pages/LeadDetail";
import Pipeline from "./admin/pages/Pipeline";
import Users from "./admin/pages/Users";
import Settings from "./admin/pages/Settings";
import EmailsDashboard from "./admin/pages/EmailsDashboard";
import EmailsLogs from "./admin/pages/EmailsLogs";
import EmailsScheduled from "./admin/pages/EmailsScheduled";
import EmailsSettings from "./admin/pages/EmailsSettings";
import Gracias from "./pages/Gracias";

function Landing() {
  useEffect(() => {
    initTracking();
    trackEvent("page_view", { ...getTrackingPayload() });
  }, []);

  return (
    <div className="App bg-eclipse text-white min-h-screen" data-testid="landing-page">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <ClientLogos />
        <Models />
        <BudgetCalculator />
        <Features />
        <Process />
        <Niches />
        <Gallery />
        <SocialProof />
        <QuoteForm />
        <Materials />
        <CatalogDownload />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <SubscriptionPopup />
      <StickyMobileCTAs />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<LeadsList />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="emails" element={<EmailsDashboard />} />
            <Route path="emails/logs" element={<EmailsLogs />} />
            <Route path="emails/scheduled" element={<EmailsScheduled />} />
            <Route path="settings/emails" element={<EmailsSettings />} />
            <Route
              path="users"
              element={
                <ProtectedRoute adminOnly>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Landing */}
          <Route path="/" element={<Landing />} />
          <Route path="/gracias" element={<Gracias />} />
          <Route path="*" element={<Landing />} />
        </Routes>
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#1F2937",
              border: "1px solid #8cb62c",
              color: "#ffffff",
              borderRadius: 0,
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
